import React from 'react';
import { MapPin } from 'lucide-react';
import { useLandingContent } from '../useLandingContent';

export default function AreaOperativa() {
  const { content } = useLandingContent();
  const COMPANY = content.company;
  return (
    <section id="area-operativa" className="py-20 sm:py-28 bg-white" data-testid="section-area-operativa">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-[11px] font-black text-primary uppercase tracking-widest mb-3">— Dove Operiamo</p>
          <h2 className="text-3xl sm:text-5xl font-black tracking-tight text-stone-900 mb-6 leading-[1.1]">
            Calcinato, Brescia<br />
            <span className="text-stone-500">e tutto il lago di Garda.</span>
          </h2>
          <p className="text-lg text-stone-600 mb-6 leading-relaxed">
            Con sede a <strong>Calcinato (BS)</strong>, raggiungiamo rapidamente cantieri in tutta la <strong>provincia di Brescia</strong>, sulla sponda bresciana del Garda e nei comuni limitrofi della Lombardia orientale.
          </p>

          <div className="flex flex-wrap gap-2 mb-8" data-testid="area-list">
            {COMPANY.servicesAreas.map(area => (
              <span key={area} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-stone-100 border border-stone-200 rounded-md text-sm font-semibold text-stone-700 hover:bg-primary hover:border-primary hover:text-primary transition-colors">
                <MapPin size={12} className="text-primary" /> {area}
              </span>
            ))}
          </div>

          <p className="text-sm text-stone-500 italic">
            Non trovi il tuo comune? <button onClick={() => document.getElementById('contatti')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-primary font-bold underline">Contattaci</button>, valutiamo ogni richiesta.
          </p>
        </div>

        <div className="relative rounded-lg overflow-hidden shadow-xl border border-stone-200 aspect-square sm:aspect-[4/3]">
          <iframe
            title="Sede EDIL CIMA S.R.L. - Calcinato BS"
            src="https://www.google.com/maps?q=Via+XX+Settembre+22,+25011+Calcinato+BS&output=embed"
            width="100%" height="100%" style={{ border: 0 }} loading="lazy" allowFullScreen
            referrerPolicy="no-referrer-when-downgrade" />
        </div>
      </div>
    </section>
  );
}
